"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationLinks = exports.LocationClass = exports.HoneLocationStatuses = void 0;
exports.HoneLocationStatuses = {
    Active: "Active",
    Inactive: "Inactive",
    Deleted: "Deleted",
};
class LocationClass {
    constructor() {
        this.name = "";
        this.id = "";
    }
}
exports.LocationClass = LocationClass;
class LocationLinks {
}
exports.LocationLinks = LocationLinks;
//# sourceMappingURL=Location.js.map